/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { Button, Header, Icon, Segment } from '@mairistem/composants';

import EnteteApercu, { HAUTEUR_ENTETE_APERCU } from './EnteteApercu';

interface ApercuIndisponibleProps {
  /** Octets du document, pour le proposer au téléchargement. */
  binaire?: Uint8Array;
  /** Nom du fichier proposé à l'enregistrement. */
  nom?: string;
  /** Titre du bandeau, aligné sur celui du canevas. */
  titre?: string;
  /** Raison de l'absence d'aperçu, affichée au centre du panneau. */
  message?: string;
}

/**
 * Panneau affiché pour un document qu'on ne sait pas rendre.
 *
 * En pratique les Word 97-2003 (`.doc` binaire), qu'aucune bibliothèque front
 * ne rend — ils sont 36 en base. Plutôt qu'un panneau vide, on propose de
 * télécharger le document pour l'ouvrir dans un traitement de texte.
 */
const ApercuIndisponible = (props: ApercuIndisponibleProps) => {
  const {
    binaire,
    nom = 'document',
    titre = 'APERÇU DU DOCUMENT',
    message = 'Ce format ne peut pas être affiché ici',
  } = props;

  const handleTelechargement = React.useCallback(() => {
    if (!binaire) return;

    const url = URL.createObjectURL(new Blob([binaire as BlobPart]));
    const lien = document.createElement('a');
    lien.href = url;
    lien.download = nom;
    lien.click();

    // Laisser au navigateur le temps de démarrer le téléchargement.
    setTimeout(() => {
      URL.revokeObjectURL(url);
      lien.remove();
    }, 5000);
  }, [binaire, nom]);

  return (
    <>
      <EnteteApercu titre={titre} />
      <Segment
        placeholder
        style={{
          height: `calc(100% - ${HAUTEUR_ENTETE_APERCU}px)`,
          margin: 0,
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
        }}
      >
        <Header icon>
          <Icon name="file alternate outline" />
          {message}
        </Header>
        {binaire && (
          <Button
            primary
            icon="download"
            data-testid="telecharger-document"
            content="Télécharger le document"
            onClick={handleTelechargement}
          />
        )}
      </Segment>
    </>
  );
};

export default ApercuIndisponible;
